import { getRoverRoutes } from '../config/rover';
import { getSherpaRoutes } from '../config/sherpa';
import { getTerminalRoutes } from '../config/terminal';

export const getNotificationRoutes = ({ platform, ...rest }: IGetNotificationRoutes) => {
  switch (platform) {
    case 'TERMINAL':
      return getTerminalRoutes(rest);
    case 'SHERPA':
      return getSherpaRoutes(rest);
    case 'ROVER':
      return getRoverRoutes(rest);
    case 'VENDOR':
      return '';
    default:
      return '';
  }
};
